import React from 'react'
import { assets } from '../../../Assets/assets'
import HeadingText from '../../common/HeadingText'


const ProgresTextBar = ({ index, text, heading }) => {
  return (
    <div className={`space-y-1 ${index === 0 ? 'border-black' : 'border-gray-400'} border-l-4 px-5 `}>
      <h1 className='flex text-primaryTextColor font-semibold md:text-xl text-lg items-start gap-1'><span className='flex gap-1'>Step:{index + 1}</span>{heading}</h1>
      <p className='text-secondaryTextColor text-justify md:text-left text-sm md:text-base'>{text}</p>
    </div>
  )
}


const OurProcess = () => {

  const processData = [
    {
      heading: 'Discover Your Dream Home', text: 'Browse through a curated selection of properties tailored to your lifestyle and budget.'
    },
    {
      heading: 'Schedule A Viewing', text: 'Book a tour at your convenience and explore the space in person or virtually.'
    },
    {
      heading: 'Seal The Deal', text: 'Get expert guidance to finalize paperwork and move into your new home with confidence.'
    },
  ]

  return (
    <section className='xl:px-20 px-6 pt-10'>
      <div className='grid lg:grid-cols-2 grid-cols-1 gap-10'>
        <article className='shadow-lg rounded-xl md:p-7 p-4'>
          <HeadingText label={'Our Process'} heading={'Homebuying Steps'} />
          <div className='space-y-7 mt-5'>
            {
              processData.map(({ text, heading }, index) => (
                <ProgresTextBar index={index} text={text} heading={heading} />
              ))
            }
          </div>
        </article>
        <figure className='lg:h-full h-[25rem] rounded-xl overflow-hidden w-full'><img className='h-full w-full object-cover object-center' src={assets.bannerProprty} alt="" /></figure>
      </div>
    </section>
  )
}

export default OurProcess